import { api } from "./api";
import {
  ITherapistActivityReportRequest,
  ITherapistActivityReportResponse,
  IPeriodicReportSavedSearch,
  ICreatePeriodicReportSavedSearchRequest,
} from "../types/periodicReports.types";

export const periodicReportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTherapistActivityReport: build.mutation<
      ITherapistActivityReportResponse,
      ITherapistActivityReportRequest
    >({
      query: (body) => ({
        url: "/Admintech/Admin_TherapistActivityReport",
        method: "POST",
        body,
      }),
    }),
    getPeriodicReportSavedSearches: build.query<IPeriodicReportSavedSearch[], void>({
      query: () => ({
        url: "/Admintech/PeriodicReportSavedSearches",
        method: "GET",
      }),
      providesTags: ["PeriodicReportSavedSearches"],
    }),
    createPeriodicReportSavedSearch: build.mutation<
      IPeriodicReportSavedSearch,
      ICreatePeriodicReportSavedSearchRequest
    >({
      query: (body) => ({
        url: "/Admintech/PeriodicReportSavedSearches",
        method: "POST",
        body,
      }),
      invalidatesTags: ["PeriodicReportSavedSearches"],
    }),
    deletePeriodicReportSavedSearch: build.mutation<void, number>({
      query: (id) => ({
        url: `/Admintech/PeriodicReportSavedSearches/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PeriodicReportSavedSearches"],
    }),
  }),
});

export const {
  useGetTherapistActivityReportMutation,
  useGetPeriodicReportSavedSearchesQuery,
  useCreatePeriodicReportSavedSearchMutation,
  useDeletePeriodicReportSavedSearchMutation,
} = periodicReportsApi;
